'use client';

import { Button, TextPassage } from '@petsmart-ui/sparky';
import { useFormContext, useWatch } from 'react-hook-form';

import type { Product } from '@libs/common-types';

import { AutoshipPurchaseOptions } from '../product-details';
import { MiniPdpAutoshipFrequency } from './mini-pdp-autoship-frequency';
import { useMiniPdpAutoship } from './model/use-mini-pdp-autoship';
import type { MiniPdpForm } from './types';

type MiniPdpAutoshipOptionsProps = Readonly<{
    product: Product;
    onOpenAutoshipInfo: () => void;
}>;

export function MiniPdpAutoshipOptions({ product, onOpenAutoshipInfo }: MiniPdpAutoshipOptionsProps) {
    const { register } = useFormContext<MiniPdpForm>();
    const purchaseOption = useWatch<MiniPdpForm, 'purchaseOption'>({ name: 'purchaseOption' });
    const { shouldRender, isLoading, isDisabled, messages } = useMiniPdpAutoship(product);

    if (!shouldRender) return null;

    return (
        <AutoshipPurchaseOptions
            selected={purchaseOption}
            inputProps={register('purchaseOption')}
            isAutoshipDisabled={isDisabled}
            isLoading={isLoading}
            messages={messages}
            infoSlot={
                <Button
                    iconName="info-outline"
                    iconSize="sm"
                    onClick={onOpenAutoshipInfo}
                    title="Autoship Information"
                    variant="bare"
                    data-testid="mini-pdp-autoship-info-button"
                    type="button"
                />
            }
            testId="mini-pdp-purchase-options"
        >
            <MiniPdpAutoshipFrequency />
            <TextPassage className="purchase-options__autoship-text" size="sm">
                Choose how you want to receive your first order below.
            </TextPassage>
        </AutoshipPurchaseOptions>
    );
}
